import axios, { AxiosError, AxiosInstance, AxiosResponse } from 'axios';
import cookie from 'helper/cookie';
import Paths from 'helper/paths';
import { toast } from 'react-toastify';

export const instance: AxiosInstance = axios.create({
  baseURL: (process && process.env.REACT_APP_BASEURL) || 'http://192.168.1.6:5000',
});

instance.defaults.headers.common = {
  ...(cookie.get('authorization') && { authorization: `Bearer ${cookie.get('authorization')}` }),
};

interface AjaxArg {
  url: string;
  method: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
  data?: any;
  headers?: any;
  showNotif?: boolean;
}

interface BaseResponse {
  success: boolean;
  message: string;
}

const ajax = async <T = any>({ url, method, data, headers, showNotif }: AjaxArg) => {
  const option: AjaxArg = {
    url,
    method,
    headers,
  };

  if (data) option.data = data;

  const res: AxiosResponse<BaseResponse & { response: T }> | AxiosError<any, any> | any = await instance(option).catch(
    (err) => {
      toast.error(err?.response?.data?.message || 'We have problem');

      if (err.response.status === 401) {
        cookie.clean();
        window.location.href = Paths.Login.index().route;
      }

      throw err;
    }
  );

  if (!res) return;

  const responseData = res.data;

  if (!responseData.success && responseData.message) toast.error(responseData.message);

  if (showNotif && responseData.message) toast.success(responseData.message);

  return responseData.response;
};

export default ajax;
